import { useDeleteMetaConversionsMutation } from '../queries/deleteMetaConversionsMutation'
import { useGetMetaConversionQuery } from '../queries/getMetaConversionQuery'
import { useUpdateMetaconversionsMutation } from '../queries/updateMetaConversionMutation'
import { useUpdateMetaConversionTestEventMutation } from '../queries/updateMetaConversionTestEventMutation'

export const useMetaConversionPixel = () => {
  const { metaConversionQuery, invalidateMetaConversionQuery } = useGetMetaConversionQuery()
  const { metaConversionUpdateMutation } = useUpdateMetaconversionsMutation()
  const { metaConversionDeleteMutation } = useDeleteMetaConversionsMutation()
  const { metaConversionTestEventUpdateMutation } = useUpdateMetaConversionTestEventMutation()

  return {
    pixelId: metaConversionQuery.data?.pixelId,
    testEventCode: metaConversionQuery.data?.testEventCode,
    isLoading: metaConversionQuery.isLoading,
    error: metaConversionQuery.error,
    loadingTestEventCode: metaConversionTestEventUpdateMutation.isLoading,
    updatePixel: ({ pixelId, accessToken }: { pixelId: string; accessToken: string }) =>
      metaConversionUpdateMutation.mutate([pixelId, accessToken], {
        onSuccess: () => {
          invalidateMetaConversionQuery()
        },
      }),
    updateTestEventCode: (testEventCode: string) => {
      metaConversionTestEventUpdateMutation.mutate([testEventCode], {
        onSuccess: () => {
          invalidateMetaConversionQuery()
        },
      })
    },
    deleteTestEventCode: () => {
      metaConversionTestEventUpdateMutation.mutate([null], {
        onSuccess: () => {
          invalidateMetaConversionQuery()
        },
      })
    },
    deletePixel: () =>
      metaConversionDeleteMutation.mutate([], {
        onSuccess: () => {
          invalidateMetaConversionQuery()
        },
      }),
  }
}
